import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

const AreYouReady = () => {
  const theme = useTheme();
  const oliveColor = theme.palette.brand?.altamiraOlive || '#2B3A1D';
  const whatsappMessage =
    'Hola, me interesa la propuesta estratégica Hotel Altamira Village x TNO Network (Plan Bienestar Village).';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
        color={theme.palette.primary.main}
      >
        ¿Listos para activar Bienestar Village?
      </Box>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 760, mx: 'auto' }}
      >
        Convirtamos la experiencia de Altamira Village en una narrativa de bienestar,
        autoridad y conversión sostenible dentro del ecosistema TNO.
      </Typography>
      <Box
        sx={{ width: 72, height: 4, bgcolor: oliveColor, borderRadius: 999, mx: 'auto', mb: 3 }}
      />
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="center"
        gap={2}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
            window.open(url, '_blank');
          }}
        >
          Activar propuesta Altamira Village
        </Button>
        <Button
          href="https://www.tnonetwork.com"
          variant="outlined"
          color="primary"
          size="large"
          target="_blank"
          rel="noopener noreferrer"
        >
          Conocer TNO Network
        </Button>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Hotel Altamira Village x TNO Network | The Content
          Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
